import {list} from "custom/demo/requests/admin/validation-surveys";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {edit: true, list, new: true};

const columns = [
  {key: "key", label: "Key"},
  {key: "name", label: "Name"},
  {key: "style", label: "Style"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Survey" path="/admin/validation/surveys" />;
}
